<template>
    <v-card>
        <v-toolbar flat dense>
            <v-toolbar-title class="text-subtitle-1">CUOTAS</v-toolbar-title>
        </v-toolbar>

        <v-divider></v-divider>
        <v-data-table :headers="columnsCuotas" :items="cuotas" :items-per-page="3" dense item-key="name"
            class="elevation-1" :search="search" :custom-filter="customFilter" :loading="loading"
            loading-text="Cargando...">
            <template v-slot:item.uuid="{ item }">
                <v-icon small class="mr-2" @click="verCuota(item.uuid)">
                    mdi-eye
                </v-icon>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
export default {
    name: 'CuotasCard',
    data() {
        return {
            columnsCuotas: [
                {
                    text: "Estado de Cuota",
                    align: "start",
                    sortable: false,
                    value: "status",
                },
                { text: "Valor a Pagar", value: "valorPagar" },
                { text: "Fecha de Pago Acordada", value: "fechaPagoAcordada" },
                { text: "Ver Cuota", value: "uuid" },
            ],
        }
    },
    props: {
        cuotas: {
            type: Array,
            required: true
        },
        search: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        },
        customFilter: {
            type: Function,
            default: null
        }
    },
    methods: {
        verCuota(uuid) {
            this.$router.push(`/visualizacion-comisiones/${uuid}`);
        },
    }
}
</script>